import React from 'react'
import { Checkbox } from 'components/forms'

export const listCols = t => ([
	{
		Header: t('common.fields.name'),
		accessor: 'name'
	}, {
		Header: t('common.fields.isActive'),
		accessor: 'isActive',
		Cell: ({ value, original }) => original?.isWindows ? null : (
			<Checkbox
				noForm
				readOnly
				checked={value}
			/>
		),
		width: 100
	}
])
